import React, { useCallback, useEffect, useState } from "react";
import "./nav.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faImagePortrait, faQrcode, faEllipsis, faUser, faIdCardClip } from "@fortawesome/free-solid-svg-icons";
import { useLocation, useNavigate } from "react-router-dom";

const TABS = [
    { key: "qr", label: "QR", icon: faQrcode, path: "/qr", color: "#e95454" },
    { key: "list", label: "모바일 신분증", icon: faImagePortrait, path: "/main", color: "#1C6DD0" },
    // { key: "more", label: "프로필", icon: faUser, path: "/profile", color: "#000" },

    // { key: "list", label: "모바일 신분증", icon: faImagePortrait, path: "/main_pre", color: "#/e95454" },
    // { key: "search", label: "자격증 정보", icon: faIdCardClip, path: "/search", color: "#1C6DD0" },    
    { key: "more", label: "더보기", icon: faEllipsis, path: "/setting", color: "#000" },
];

const keyFromPath = (pathname) => {
    if (pathname.startsWith("/qr")) return "qr";
    if (pathname.startsWith("/profile")) return "more";
    if (pathname.startsWith("/main")) return "list";    

    
    if (pathname.startsWith("/main_pre")) return "list";    
    if (pathname.startsWith("/setting")) return "more";
    if (pathname.startsWith("/search")) return "list";
    if (pathname.startsWith("/certificate-manage")) return "more";
    return "list";
};

export default function Footer() {
    const navigate = useNavigate();
    const location = useLocation();
    const [active, setActive] = useState(keyFromPath(location.pathname));

    useEffect(() => {
        setActive(keyFromPath(location.pathname));
    }, [location.pathname]);

    const onActivate = useCallback((tab) => {
        setActive(tab.key);
        navigate(tab.path);
    }, [navigate]);

    const onKey = useCallback((e, tab) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onActivate(tab);
        }
    }, [onActivate]);

    return (
        <div className="footer">
            <nav className="main-tabbar" role="tablist" aria-label="하단 탭" style={{
                borderBottom: "1px solid #e7e7e7"
            }}>
                {TABS.map((t) => {
                    const isActive = active === t.key;
                    return (
                        <button
                            key={t.key}
                            type="button"
                            role="tab"
                            aria-selected={isActive}
                            className={`main-tab ${isActive ? "active" : ""}`}
                            onClick={() => onActivate(t)}
                            onKeyDown={(e) => onKey(e, t)}
                            tabIndex={0}
                        >
                            <div className="main-tab-box">
                                <span className={`main-tab-icon ${t.key}`} aria-hidden>
                                    <FontAwesomeIcon icon={t.icon} />
                                </span>
                                <span className={`main-tab-label ${t.key}`}>{t.label}</span>
                            </div>
                        </button>
                    );
                })}
            </nav>
        </div>
    );
}
